import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@dc/ui-library/src/molecules/Button/Button';
import Input from '@dc/ui-library/src/molecules/Input/Input';
import Icon from '@dc/ui-library/src/molecules/Icon/Icon';
import Select from '@dc/ui-library/src/molecules/Select/Select';
import { setEmailMeBackProductID, setEmailMeBackXhrResponse }
  from '../../../../appState/ducks/listingPageProducts';
import { postEmailMeBackForm } from '../../../../appState/ducks/network';
import { createMarkup } from '../helpers';

const validateEmail = (email) =>
  /^[a-z0-9._+-]+@[a-z0-9._-]+\.[a-z]{2,4}$/i.test(String(email).toLowerCase());

class EmailBack extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedTitleId: 0,
      name: '',
      surname: '',
      email: ''
    };

    this.submitForm = this.submitForm.bind(this);
  }

  componentWillUnmount() {
    this.props.setEmailMeBackXhrResponse(null);
  }

  submitForm(e) {
    e.preventDefault();
    this.props.postEmailMeBackForm({
      productID: this.props.emailWhenBackFormProductID,
      name: this.state.name,
      surname: this.state.surname,
      email: this.state.email,
      titleId: this.state.selectedTitleId
    });
  }

  renderXhrResponse() {
    return (
      <div
        dangerouslySetInnerHTML={createMarkup(this.props.emailWhenBackXhrResponseContent)}
      />
    );
  }

  renderForm() {
    return (
      <div>
        <span className={'email-when-back-title'}>
          {this.props.translations.title}
        </span>
        <p className={'email-when-back-legend'}>
          {this.props.translations.legend}
        </p>
        <div className={'inline-ps'}>
          <div className={'inputField'}>
            <Select
              label={this.props.translations.selectLabel}
              name={'title_id'}
              selected={this.state.selectedTitleId}
              options={this.props.translations.selectTitles}
              onSelect={(id) => this.setState({ selectedTitleId: id })}
              isValid
            />
          </div>
          <div className={'inputField'}>
            <Input
              type={'text'}
              name={'first_name'}
              value={this.state.name}
              label={this.props.translations.name}
              updateValue={(value) => this.setState({ name: value })}
              isValid={this.state.name.length > 0}
            />
          </div>
          <div className={'inputField'}>
            <Input
              type={'text'}
              name={'last_name'}
              value={this.state.surname}
              label={this.props.translations.surname}
              updateValue={(value) => this.setState({ surname: value })}
              isValid={this.state.surname.length > 0}
            />
          </div>
        </div>

        <div className={'inputField email-field'}>
          <Input
            type={'email'}
            name={'email'}
            value={this.state.email}
            label={this.props.translations.email}
            updateValue={(value) => this.setState({ email: value })}
            isValid={validateEmail(this.state.email)}
          />
        </div>
        <span className={'mandatory-text'}>{this.props.translations.mandatoryText}</span>

        <div className={'dc-site-currys sg-gutter-bottom'}>
          {validateEmail(this.state.email)
            ? <Button style={'full'}>Submit</Button>
            : <Button style={'full'} disabled>Submit</Button>}
        </div>
      </div>
    );
  }
  
  render() {
    return (
      <form
        id={'email-when-back-form'}
        className={'email-when-back-ajax'}
        onSubmit={this.submitForm}
      >
        <span
          className={'closeFormButton'}
          onClick={() => {
            this.props.setEmailMeBackProductID(null);
          }}
        >
          Close
          <Icon icon={'Cross'} />
        </span>
        {this.props.emailWhenBackXhrResponseContent
          ? this.renderXhrResponse() : this.renderForm()}

      </form>
    );
  }
}

EmailBack.displayName = 'EmailBack';

EmailBack.propTypes = {
  emailWhenBackFormProductID: PropTypes.string.isRequired,
  setEmailMeBackProductID: PropTypes.func,
  emailWhenBackXhrResponseContent: PropTypes.string,
  translations: PropTypes.shape({
    selectLabel: PropTypes.string.isRequired,
    selectTitles: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
    name: PropTypes.string.isRequired,
    surname: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    submit: PropTypes.string.isRequired,
    mandatoryText: PropTypes.string.isRequired,
    legend: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired,
  postEmailMeBackForm: PropTypes.func.isRequired,
  setEmailMeBackXhrResponse: PropTypes.func
};

EmailBack.defaultProps = {
  setEmailMeBackProductID: () => {},
  setEmailMeBackXhrResponse: () => {},
  emailWhenBackXhrResponseContent: null
};

function mapStateToProps(state) {
  return {
    emailWhenBackFormProductID: state.listingPage.products.emailWhenBackFormProductID,
    emailWhenBackXhrResponseContent: state.listingPage.products.emailWhenBackXhrResponseContent
  };
}

const dispatchFunctions = {
  setEmailMeBackProductID,
  postEmailMeBackForm,
  setEmailMeBackXhrResponse
};

export default connect(mapStateToProps, dispatchFunctions)(EmailBack);
